export const GET_MESSAGES = "GET_MESSAGES";
export const DELETE_MESSAGE = "DELETE_MESSAGE";
